export { percentToNumber, round } from './number.js';
